export default __webpack_public_path__ + "media/zurb/img/party/foundation-4616044e9918df08592af71814bf2ef2.png";